const state = {
    clientHeight: '900',
    clientWidth: '1313',
    nowSemester: {
        id: 2,
        name: "港龙春季班"
    },
    section: {
        id: 1,
        name: "港龙"
    },
    sections:[],
    config: '',
    powers: [],
    currentUsers: [],
};

const mutations = {
    windowsConfig(state, data) {
        state.clientHeight = data.clientHeight;
        state.clientWidth = data.clientWidth;
    },
    setPowers(state, data) {
        state.powers = data.powers
    },
    setSemester(state, data) {
        state.nowSemester = data.semester
    },
    setSection(state, data) {
        state.section = data.section
    },
    setSections(state, data) {
        state.sections = data.sections
    },
    setConfig(state, data) {
        state.config = data.config
    },
    setCurrentUsers(state, data) {
        state.currentUsers = data.currentUsers
    }
};

const actions = {};

export default {
    state,
    mutations,
    actions
}
